import { FC, Fragment } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItemGenre from '@/components/ui/book-card-item/BookCardItemGenre';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import CheckBoxFreeBook from '@/components/ui/checkbox-free-book/CheckBoxFreeBook';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { getFirstLetterCaps } from '@/helpers/helpers';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { getCurrentPageName } from '@/helpers/helpers';

interface IGenreProps extends IWidgetsSideBar {
  books: IGenreBooksPage;
  freeBooks?: boolean;
}

const Genre: FC<IGenreProps> = ({ books, freeBooks, todayWidget, popularBooksWidget }) => {
  const genreName = getFirstLetterCaps(books.title);
  const genreAlias = books.alias;
  const pagesCount = Math.ceil(books?.books.total_count / BOOKS_FOR_PAGE);

  //Seo
  const SEO_TITLE = `Книги жанра ${genreName} - скачать бесплатно в fb2 или читать онлайн | Bookz.ru${getCurrentPageName(books.books.page)}`;
  const SEO_DESCRIPTION = `Скачать бесплатно книги жанра ${genreName} в формате fb2, epub, pdf или читать онлайн на сайте Bookz.ru.`;
  const SEO_CANONICAL = `/genres/${genreAlias}`;

  return (
    <Layout
      title={SEO_TITLE}
      description={SEO_DESCRIPTION}
      canonicalHref={SEO_CANONICAL}
      pageHref={useGetUrlPath()}
      breadcrumbs={<Breadcrumbs firstPageName="Жанры" firstPageAlias="/genres/" secondPageName={genreName} />}
      todayWidget={todayWidget}
      popularBooksWidget={popularBooksWidget}
    >
      <SectionTitle name={`Книги жанра ${genreName}`} />
      <CheckBoxFreeBook freeBooks={!!freeBooks} alias={`/genres/${genreAlias}`} />
      <div>
        {books.books && books.books.data.length > 0 ? (
          books.books.data.map((book, i) => (
            <Fragment key={`${book.id}-${i}`}>
              <BookCardItemGenre book={book} />
            </Fragment>
          ))
        ) : (
          <div>Нет книг</div>
        )}
      </div>
      <Pagination defaultCurrentPage={books.books.page} pagesCount={pagesCount ?? 0} postName={freeBooks ? `genres/${genreAlias}/?free_books=true&page=` : `genres/${genreAlias}/page=`} />
    </Layout>
  );
};

export default Genre;
